import React from 'react';

const toOptions = (keyval) => {
    return keyval.map((k, i) => {
        return <option key={i} value={k.key}> {k.value} </option>
    })
};

export default toOptions;